import { render, staticRenderFns } from "./ExpensesShow.vue?vue&type=template&id=723125d9&"
import script from "./ExpensesShow.vue?vue&type=script&lang=js&"
export * from "./ExpensesShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports